import { Post } from "../view/home/blog/BlogView";

export default class AppCache {
  static blogPosts: Post[] = [];
}
